// [BD feat] Featured Product List (product-row) — bd-featured-product-list.js
// The "new arrivals" row (snippets/bd-featured-product-list-product-row.liquid) is a
// plain overflow-x:auto <ul> with its scrollbar hidden by design (assets/bd-featured-
// product-list.css). Trackpad/touch users already pan it natively; this adds a desktop
// mouse-only click-and-drag pan (there's no visible scrollbar for a mouse to grab
// otherwise). Deliberately NOT a wheel-to-horizontal handler: hovering the row while
// scrolling the page vertically is far more common than deliberately trying to scroll
// the row itself (it spans the full row width, so the cursor sits over it for most of
// a normal page scroll) — hijacking that wheel gesture made the row appear to
// "auto-scroll" sideways on its own every time someone scrolled the page past it.
//
// Drag is a plain 1:1 pan that stops wherever it's released and never calls scrollTo —
// same approach and same reasoning as assets/bd-search-drawer.js's carousel drag (verified
// working there first): theme.js's own <scroll-carousel allow-drag> (assets/theme.js)
// snaps/re-centers to the nearest cell on mouseup, which is built for carousels with
// prev/next buttons stepping one card at a time, not a free-scrolling row like this one.
// Also mirrors that file's mousedown/mousemove(document)/mouseup wiring and its
// draggable="false" + -webkit-user-drag: none treatment of the card <a>/<img>
// (snippets/bd-featured-product-list-card.liquid, assets/bd-featured-product-list.css):
// without that, a drag that starts on the product image is hijacked by the browser's
// native "drag this image out" gesture partway through — mousemove stops arriving
// entirely once that kicks in, which is what made an earlier version of this drag freeze
// after the first pixel of movement instead of tracking the cursor.
(function () {
  'use strict';

  function initTrack(track) {
    if (track.hasAttribute('data-bd-featured-product-list-init')) return;
    track.setAttribute('data-bd-featured-product-list-init', '');

    // Mouse-only (fine pointers) — touch already scrolls natively and shouldn't get a
    // second, competing handler.
    if (!window.matchMedia('(pointer: fine)').matches) return;

    var dragged = false;
    var startX = 0;
    var startScrollLeft = 0;

    function onMouseMove(event) {
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 3) dragged = true;
      track.scrollLeft = startScrollLeft - delta;
    }

    function onMouseUp() {
      track.classList.remove('is-dragging');
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }

    track.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;
      dragged = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    // A drag that moved the cursor shouldn't also follow the link it started on.
    track.addEventListener('click', function (event) {
      if (dragged) {
        event.preventDefault();
        dragged = false;
      }
    }, true);
  }

  function initScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('.bd-featured-product-list-row__track').forEach(initTrack);
  }

  initScope(document);

  // Shopify theme editor support: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector('.bd-featured-product-list-row__track')) return;
    initScope(event.target);
  });
})();
// [/BD feat] Featured Product List (product-row)
